import React from 'react';
import Sidebar from './sidebar/Sidebar.jsx';
import MainSidebar from './sidebar/MainSidebar.jsx';

const MainWithSidebar = ({ children }) => (
  <div className="blockcontent">
    <Sidebar>
      <MainSidebar/>
    </Sidebar>
    <div className="main" id="main">
      {children}
    </div>
  </div>
);

export default MainWithSidebar;




// WEBPACK FOOTER //
// ./book/src/commons/components/layout/MainWithSidebar.jsx